import { StatusIndicator } from '@amzn/awsui-components-react-v3/polaris';
import React from 'react';

export interface ReviewStatusProps {
  status: string;
}

export function ReviewStatus(props: ReviewStatusProps) {
  switch (props.status) {
    case 'PENDING_CUSTODIAN_REVIEW':
      return <StatusIndicator type='warning'>Pending custodian review</StatusIndicator>;
    case 'PENDING_CONSUMER_REVIEW':
      return <StatusIndicator type='warning'>Consumer action required</StatusIndicator>;
    case 'CREATED':
      return <StatusIndicator type='info'>Not yet reviewed</StatusIndicator>;
    case 'REJECTED':
      return <StatusIndicator type='error'>Rejected</StatusIndicator>;
    case 'EXPIRED':
      return <StatusIndicator type='stopped'>Expired</StatusIndicator>;
    case 'COMPLETED':
      return <StatusIndicator type='success'>Completed</StatusIndicator>;
    case 'NEEDS_MORE_DATA':
      return <StatusIndicator type='warning'>Requested additional information</StatusIndicator>;
    case 'APPROVE':
      return <StatusIndicator type='success'>Approved</StatusIndicator>;
    case 'DENY':
      return <StatusIndicator type='error'>Denied</StatusIndicator>;
    default:
      return <StatusIndicator type='info'>{props.status ?? '-'}</StatusIndicator>;
  }
}
